module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('form', {
    class: [_vm.isInline]
  }, [_vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-3a2bf0d4!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/form/form.vue
// module id = 307
// module chunks = 2